module.exports = __webpack_public_path__ + "static/img/water1.2d4da141.webp";